export default {
  methods: {
    getTelefone (cliente, instanciaCliente) {
      return cliente.telefone_residencial || (instanciaCliente && instanciaCliente.telefone_comercial) ||
          (cliente && cliente.telefone_comercial) || '-'
    },
    getTelefoneCelular (instanciaCliente, cliente) {
      return (
        (instanciaCliente && instanciaCliente.telefone_celular) ||
        (cliente && cliente.telefone_celular) ||
        '-'
      )
    }
  }
}
